import * as React from "react";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import MenuIcon from "@mui/icons-material/Menu";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import LOGO from "../../asset/logo_white.png";
import { MenuItem } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 824,
    height: 50,
    width: "100%",
    backgroundColor: "#EB5FE5",
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
  },
  img: {
    maxWidth: 130,
  },
}));

type Anchor = "top" | "left" | "bottom" | "right";

export default function MobileHeader() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  // const [state, setState] = React.useState({
  //   top: false,
  //   left: false,
  //   bottom: false,
  //   right: false,
  // });

  // const toggleDrawer =
  //   (anchor: Anchor, open: boolean) =>
  //   (event: React.KeyboardEvent | React.MouseEvent) => {
  //     if (
  //       event.type === "keydown" &&
  //       ((event as React.KeyboardEvent).key === "Tab" ||
  //         (event as React.KeyboardEvent).key === "Shift")
  //     ) {
  //       return;
  //     }

  //     setState({ ...state, [anchor]: open });
  //   };

  const list = (anchor: Anchor) => (
    <div>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>회사소개</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/vision">
            비전&미션
          </MenuItem>
        </AccordionDetails>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/history">
            연혁
          </MenuItem>
        </AccordionDetails>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/team">
            팀구성
          </MenuItem>
        </AccordionDetails>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/result">
            사업성과
          </MenuItem>
        </AccordionDetails>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/research">
            수상&연구
          </MenuItem>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography>심브릿지 시뮬레이션</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/simintro">
            사업소개
          </MenuItem>
        </AccordionDetails>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/simfeature">
            특장점
          </MenuItem>
        </AccordionDetails>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/simcontent">
            사업내용
          </MenuItem>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel3a-header"
        >
          <Typography>창업과 경영 교육과정</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/mba4intro">
            사업소개
          </MenuItem>
        </AccordionDetails>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/mba4content">
            사업내용
          </MenuItem>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel4a-header"
        >
          <Typography>방문간호센터 경영솔루션</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/3sbisintro">
            사업소개
          </MenuItem>
        </AccordionDetails>

        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/3sbiscontent">
            사업내용
          </MenuItem>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel5a-header"
        >
          <Typography>노인 돌봄 교육과정</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/eldintro">
            사업소개
          </MenuItem>
        </AccordionDetails>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/eldcontent">
            사업내용
          </MenuItem>
        </AccordionDetails>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/eldcontent2">
            보도자료
          </MenuItem>
        </AccordionDetails>
        <AccordionDetails
          sx={{
            padding: "0px 16px 0px",
          }}
        >
          <MenuItem component="a" href="/eldcontent3">
            홍보영상
          </MenuItem>
        </AccordionDetails>
      </Accordion>
    </div>
  );

  return (
    <div className={classes.root}>
      <Button
        onClick={() => {
          setOpen(true);
        }}
      >
        {<MenuIcon sx={{ color: "white" }} />}
      </Button>
      <Drawer
        anchor={"left"}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        {list("left")}
      </Drawer>

      <div>
        <a href="/">
          <img src={LOGO} className={classes.img} alt="logo" />
        </a>
      </div>
    </div>
  );
}
